import classes from './styles.module.css';
import React from 'react';
import Heart from '@app/components/Icons/Heart';

export default function Signature() {
  return (
    <div className={classes.signature}>
      Feito com <Heart color="#e57373" size={17} /> no Cliquei Achei Labs
    </div>
  );
}
